import { useRedirectIfNotLoggedIn } from '../../util/hooks';
import { CheckoutRoute, CheckoutRouteProps } from './checkout-route';

export const AuthenticatedCheckoutRoute = (props: CheckoutRouteProps) => {
  useRedirectIfNotLoggedIn();

  return <CheckoutRoute {...props} />;
};
